import { CURRENT_USER } from './Base';

export const onGetRequest = (params = {}, cb) => ({ params, type: CURRENT_USER.GET_REQUEST, cb });
export const onGetSuccess = (payload = {}, cb) => ({ payload, type: CURRENT_USER.GET_SUCCESS, cb });
export const onGetFailure = (payload = {}, cb) => ({ payload, type: CURRENT_USER.GET_FAILURE, cb });

export const onSetLanguageRequest = (params = {}, cb) => ({ params, type: CURRENT_USER.SET_LANGUAGE_REQUEST, cb });
export const onSetLanguageSuccess = (payload = {}, cb) => ({ payload, type: CURRENT_USER.SET_LANGUAGE_SUCCESS, cb });
export const onSetLanguageFailure = (payload = {}, cb) => ({ payload, type: CURRENT_USER.SET_LANGUAGE_FAILURE, cb });

export const onSetProfilePictureRequest = (payload = {}, cb) => ({ payload, type: CURRENT_USER.SET_PROFILE_PICTURE_REQUEST, cb });
export const onSetProfilePictureSuccess = (payload = {}, cb) => ({ payload, type: CURRENT_USER.SET_PROFILE_PICTURE_SUCCESS, cb });
export const onSetProfilePictureFailure = (payload = {}, cb) => ({ payload, type: CURRENT_USER.SET_PROFILE_PICTURE_FAILURE, cb });